Namespace 'Settings.ChatbotConfiguration'

class Settings.ChatbotConfiguration.Intent extends Backbone.Model
  defaults:
    id: 0
    description: ''
    modifiers: []
    selected: ''
    updated_at: '1900-01-01T00:00:00-00:00'
    updated_by: ''
    update_reason: ''

  formattedDate: =>
    Date.create(@get('updated_at')).format('DD/MM/YYYY')

class Settings.ChatbotConfiguration.IntentCollection extends Backbone.Collection
  model: Settings.ChatbotConfiguration.Intent
  url: '/keepcon/settings/chatbot_configuration/fetch_intents'
  saveUrl: '/keepcon/settings/chatbot_configuration/submit_intents'

  parse: (response) =>
    if response.success
      @intents = response.intents
    else
      @trigger('intents:fetch:error', response)

  fetchFor: (chatbotCode) =>
    @fetch({
      data: $.param({ chatbot: chatbotCode})
      success: => @trigger('intents:fetch:success')
      error: => @trigger('intents:fetch:error', response)
    })

  saveFor: (chatbotCode) =>
    intents = _.map(@models, (model) => model.toJSON())

    $.ajax({
      type : "POST",
      url :  @saveUrl,
      dataType: 'json',
      contentType: 'application/json',
      data : JSON.stringify({ chatbot: chatbotCode, intents: intents })
    });

  handleSave: (response) =>
    if response.success
      @trigger('intents:save:success')
    else
      @trigger('intents:save:error', response)

  normalFlow: =>
    @where(selected: 'NONE')

  disabledFlow: =>
    @where(selected: 'DISABLED')

  fallbackFlow: =>
    @where(selected: 'FALLBACK')
